import type { Failure } from "@/modules/shared/failure";
import { SYSTEM_ERROR, type FormState } from "@/modules/shared/forms";

/**
 * The clinic switcher's copy (H37, R22 T14).
 *
 * Lifted out of `./activeBusiness.ts` so the static web app renders the same
 * sentence and a test can pin it. That matters here more than it looks:
 *
 * **The one refusal is deliberately the same sentence for two different
 * situations**, a clinic that was archived out from under the member and a
 * business id that was never theirs. Telling those apart would answer "does
 * this business exist" for anybody who posts a guess. A second copy of this
 * map is a second chance for somebody to "improve" it into an oracle.
 */
export const NOT_YOURS =
  "That clinic is no longer available to you. Refresh to see your clinics.";

export function switchStateFor(failure: Failure): FormState {
  return {
    formError: failure.code === "not_found" ? NOT_YOURS : SYSTEM_ERROR,
  };
}
